<div class="container">
  <ion-searchbar
    [placeholder]="'machinery.search' | translate"
    show-clear-button="focus"
    (ionInput)="handleSearchInput($event)"
  ></ion-searchbar>
  <div class="custom-table">
    <div class="row header">
      <div class="col" style="display: flex; align-items: center">
        Datum
        <ion-icon
          size="small"
          style="color: black; cursor: default"
          name="caret-down-outline"
        ></ion-icon>
      </div>
      <div class="col grow">Maschine</div>

      <div class="col">Status</div>
    </div>

    @for (wd of filteredEntries; track wd) {
    <div class="row" (click)="openDetailModal(wd.id)">
      <div class="col">{{ toolService.formatDt(wd.dateUtc) }}</div>
      <div class="col grow">{{ wd.machineName }}</div>
      <div class="col">
        @if(wd.approvedBy != null){
        <ion-icon
          class="green"
          size="small"
          name="checkmark-circle-outline"
        ></ion-icon>
        } @else{
        <ion-icon
          class="orange"
          size="small"
          name="checkmark-circle-outline"
        ></ion-icon>
        }
      </div>
    </div>
    }
  </div>
  <lib-table-legend [items]="[0, 1]"></lib-table-legend>
</div>
